import React, { ReactElement, useCallback } from 'react';
import isEqual from 'lodash.isequal';
import { useToggle } from 'b2b-apps/shop/common/hooks';
import { useCheckPermissions, useUserData } from 'b2b-apps/shop/context/hooks';
import { PERMISSION } from 'b2b-apps/shop/context/utils/permissions';
import { EnhancedComponentProps, EnhancedComponentType, InjectedProps, WrappedComponentType } from './';

const withContainer = (Component: WrappedComponentType): EnhancedComponentType => {
  const WithContainer = (props: EnhancedComponentProps): ReactElement => {
    const [isModalOpened, setIsModalOpened] = useToggle();
    const {
      isLoggedIn,
      isPrivate,
    } = useUserData();
    const hasUserPdfExportPermissions = useCheckPermissions([
      PERMISSION.productPdfExport,
    ]);

    const toggleModal = useCallback(() => setIsModalOpened(), [
      setIsModalOpened,
    ]);

    const injectedProps: InjectedProps = {
      hasUserPdfExportPermissions,
      isLoggedIn,
      isModalOpened,
      isPrivate,
      toggleModal,
    };

    return <Component {...props} {...injectedProps} />;
  };

  return React.memo(WithContainer, (prevProps, nextProps) => isEqual(prevProps, nextProps));
};

export { withContainer };
